import { Container, ContainerProps } from '@mantine/core'
import styles from './Logo.module.css'

interface Props extends ContainerProps {
  size?: 'sm' | 'md' | 'lg'
}

export default function Logo({ size = 'md', ...props }: Props) {
  let sizeClass = ''
  if (size === 'sm') {
    sizeClass = styles.sm
  } else if (size === 'lg') {
    sizeClass = styles.lg
  } else {
    sizeClass = styles.md
  }

  return (
    <Container {...props} m={0}>
      <div className={`${styles.logo} ${sizeClass}`}>
        <span className={styles.abc}>abc</span>firany.pl
      </div>
    </Container>
  )
}
